<template>
  <div class='ml-10'>
    <div class='mb-2 d-flex align-center justify-end'>
      <v-btn text x-small class='ml-0' color='primary' depressed
             @click='openNewKvDialog'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiPlusCircleOutline }}</v-icon>
        <span class='ml-1'>新增</span>
      </v-btn>
      <v-btn text x-small class='ml-1' color='primary' depressed
             @click='refresh'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiRefresh }}</v-icon>
        <span class='ml-1'>刷新</span>
      </v-btn>
    </div>
    <vxe-table
      style='z-index: 2'
      ref='dataTable'
      class='scroll-table'
      border
      resizable
      show-header-overflow
      show-overflow
      :height='tableHeight'
      :loading='tableLoading'
      size='small'
      :row-config='{isHover: true}'
      :data='dataList'
      @filter-change='search'
      :filter-config='{ remote: true }'
    >
      <vxe-column field='cityValue' title='City'>
      </vxe-column>
      <vxe-column field='buildingValue' title='Building'>
      </vxe-column>
      <vxe-column field='floorValue' title='Floor'>
      </vxe-column>
      <vxe-column field='roomName' title='Room'>
      </vxe-column>
      <vxe-column field='createBy' title='Create By' width='200'>
      </vxe-column>
      <vxe-column field='createTime' width='150' title='Create Time' sortable
                  show-header-overflow show-overflow />
      <!--      <vxe-column title='Option' width='100' align='center'>-->
      <!--        <template #default='{ row }'>-->
      <!--          <v-btn color='primary' text class='mr-1' x-small @click='openEditCategoryDialog(row)'>-->
      <!--            <v-icon small>{{ icons.mdiPencil }}</v-icon>-->
      <!--          </v-btn>-->
      <!--          <v-btn color='primary' text x-small-->
      <!--                 @click='openDeleteKvDialog(row)'>-->
      <!--            <v-icon small>{{ icons.mdiDelete }}</v-icon>-->
      <!--          </v-btn>-->
      <!--        </template>-->
      <!--      </vxe-column>-->
    </vxe-table>
    <vxe-pager
      :current-page='pagerOption.pageNum'
      :page-size='pagerOption.pageSize'
      :total='pagerOption.totalData'
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :page-sizes='[10, 20, 50, 100]'
      @page-change='changePerPage'
    />
    <v-dialog
      v-model='newKvDialog'
      width='400'
      persistent
    >
      <v-card>
        <v-card-title class='text-h6 py-3'>
          <span v-if='!kvParams.id'>新增</span>
          <span v-else>编辑</span>
        </v-card-title>

        <v-card-text>
          <v-form ref='kvForm'>
            <v-text-field
              outlined
              dense
              hide-details
              :rules='[v => !!v]'
              label='分类名称'
              v-model='kvParams.categoryName'
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color='primary'
            text
            small
            @click='closeKvDialog'
          >
            取消
          </v-btn>
          <v-btn
            color='primary'
            small
            @click='submitCategory'
            :loading='submitKvLoading'
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model='deleteKvDialog'
      width='400'
      persistent
    >
      <v-card>
        <v-card-title class='text-h6 py-3'>
          删除
        </v-card-title>

        <v-card-text>
          您确定要删除此分类吗？
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color='primary'
            text
            small
            @click='clearForm(); deleteKvDialog = false'
          >
            取消
          </v-btn>
          <v-btn
            color='primary'
            small
            @click='deleteDataFunc()'
            :loading='deleteKvLoading'
          >
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  addCategory,
  getCategoryPageList,
  deleteCategoryById,
  updateCategory,
} from '../api/index'
import {
  mdiPencil,
  mdiDelete,
  mdiPlusCircleOutline,
  mdiRefresh,
} from '@mdi/js'

export default {
  data() {
    return {
      tableLoading: false,
      dataList: [
        {
          cityValue: 'Dalian',
          buildingValue: 'Software Park Tower 24',
          floorValue: '2F',
          roomName: '24-4M001',
          createBy: 'jingxin.zhou',
          createTime: '2025-02-20 09:46:36',
        },
        {
          cityValue: 'Dalian',
          buildingValue: 'Software Park Tower 27',
          floorValue: '1F',
          roomName: '27-1F001',
          createBy: 'jingxin.zhou',
          createTime: '2025-02-19 13:12:05',
        },
      ],
      pagerOption: {
        pageNum: 1,
        pageSize: 20,
        totalData: 0,
      },
      icons: {
        mdiPencil, mdiDelete, mdiPlusCircleOutline, mdiRefresh,
      },
      searchParams: {
        categoryName: null,
      },
      newKvDialog: false,
      kvParams: {
        categoryName: null,
        id: null,
      },
      submitKvLoading: false,
      deleteKvDialog: false,
      deleteKvLoading: false,
      tableHeight: 0,
    }
  },
  created() {
    this.getPageList()
  },
  mounted() {
    this.getScreenHeight()
    // 监听窗口大小变化事件
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('resize', this.getScreenHeight)
  },
  methods: {
    getScreenHeight() {
      this.tableHeight = window.innerHeight - 64 - 50 - 50
    },
    openNewKvDialog() {
      this.clearForm()
      this.newKvDialog = true
    },
    async submitCategory() {
      if (this.$refs.kvForm.validate()) {
        this.submitKvLoading = true
        if (this.kvParams.id) {
          this.updateKv()
        } else {
          this.saveKv()
        }
        this.submitKvLoading = false
      }
    },
    async saveKv() {
      const {
        data: {
          code,
          data,
          msg,
        },
      } = await addCategory(this.kvParams)
      if (code === 200) {
        this.$message.success('保存成功')
        this.newKvDialog = false
        this.getPageList()
      } else {
        this.$message.error(msg)
      }
    },
    async updateKv() {
      const {
        data: {
          code,
          data,
          msg,
        },
      } = await updateCategory(this.kvParams)
      if (code === 200) {
        this.$message.success('更新成功')
        this.newKvDialog = false
        this.getPageList()
      } else {
        this.$message.error(msg)
      }
    },
    async openEditCategoryDialog(row) {
      this.kvParams.categoryName = row.categoryName
      this.kvParams.id = row.id
      this.newKvDialog = true
    },
    async openDeleteKvDialog(row) {
      this.kvParams.categoryName = row.categoryName
      this.kvParams.id = row.id
      this.deleteKvDialog = true
    },
    async deleteDataFunc() {
      const {
        data: {
          code,
          data,
          msg,
        },
      } = await deleteCategoryById({ id: this.kvParams.id })
      if (code === 200) {
        this.$message.success('删除成功')
        this.deleteKvDialog = false
        this.getPageList()
      } else {
        this.$message.error(msg)
      }
    },
    clearForm() {
      this.kvParams.categoryName = null
      this.kvParams.id = null
    },
    closeKvDialog() {
      this.$refs.kvForm.reset()
      this.newKvDialog = false
      this.clearForm()
    },
    search(params) {
      const { filters } = params
      console.log('🚀 ~ search ~ filters:', filters)
      this.searchParams.createBy = null
      this.searchParams.nameOfJobList = []
      filters.forEach(item => {
        this.searchParams[item.property] = item.datas[0]
      })
      console.log(this.searchParams)
      this.getPageList()
    },
    changePerPage(currentPage) {
      this.pagerOption.pageNum = currentPage.currentPage
      this.pagerOption.pageSize = currentPage.pageSize
      this.getPageList()
    },
    async getPageList() {
      this.tableLoading = true
      // const {
      //   data: {
      //     code,
      //     data,
      //   },
      // } = await getCategoryPageList({ ...this.pagerOption, ...this.searchParams })
      // if (code === 200) {
      //   this.dataList = data.records
      //   this.pagerOption.totalData = data.total
      // }
      this.tableLoading = false
    },
  },
}
</script>
